import React, { useEffect } from 'react';
import {
  useMsal,
  useIsAuthenticated,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './msalConfig';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Route guard component.
 *
 * - If the user is authenticated, renders children.
 * - If the user is not authenticated and no interaction is in progress,
 *   initiates OIDC login via redirect (preserving the originally requested route).
 */
export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      // Initiate login, MSAL will redirect back to the current URL after success
      instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: window.location.href,
      });
    }
  }, [isAuthenticated, inProgress, instance]);

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {inProgress !== InteractionStatus.None ? (
          <div aria-busy="true" aria-label="Authenticating">
            Autenticando...
          </div>
        ) : null}
      </UnauthenticatedTemplate>
    </>
  );
};
